// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconShoppingPath = 'M11.975 9.937v1.586l-2 2-1.586-1.586 2-2h1.586Zm4.427 7.112c-.06.506-.49.888-.997.888H4.545c-.508 0-.937-.382-.997-.887l-.22-1.868-1.079-9.245H13.975c0 1.103-.897 2-2 2H9.56l-4 4 4.414 4.414 4-4v-2.97c1.19-.694 2-1.97 2-3.444h1.727l-1.3 11.112ZM9.612 2.032a1.95 1.95 0 0 1 1.624.426c.44.37.697.904.727 1.48H7.996c.1-.95.759-1.749 1.616-1.906Zm4.362 1.905A4.061 4.061 0 0 0 12.519.924a3.97 3.97 0 0 0-3.265-.86C7.432.4 6.089 2.007 5.982 3.937H0l1.562 13.349a3.006 3.006 0 0 0 2.983 2.65h10.86a3.007 3.007 0 0 0 2.983-2.652l1.56-13.347h-5.974Z';
var IconShopping = baseIcon('IconShopping', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconShoppingPath
});
export default IconShopping;
//# sourceMappingURL=index.js.map